/**
 * ============================================================================
 * RK PRODUCT HERO JAVASCRIPT
 * Product Detail Page Interactions
 * ============================================================================
 *
 * Powered by René Kress - Crovio
 * www.crovio.de
 *
 * © 2025 All Rights Reserved
 * ============================================================================
 */

(function() {
  'use strict';
  
  const productSection = document.querySelector('.rk-product-hero');
  if (!productSection) return;
  
  // Get Product JSON
  let product = null;
  try {
    const productJson = document.getElementById('rk-product-json');
    if (productJson && productJson.textContent) {
      product = JSON.parse(productJson.textContent);
      console.log('RK Product Hero - Product loaded:', product?.title);
    }
  } catch (error) {
    console.error('RK Product Hero - Error parsing product JSON:', error);
  }
  
  // Get Delivery Settings
  let deliverySettings = null;
  try {
    const deliverySettingsEl = document.getElementById('rk-delivery-settings');
    if (deliverySettingsEl && deliverySettingsEl.textContent) {
      deliverySettings = JSON.parse(deliverySettingsEl.textContent);
      console.log('RK Product Hero - Delivery settings loaded:', deliverySettings);
    }
  } catch (error) {
    console.error('RK Product Hero - Error parsing delivery settings:', error);
  }
  
  // Elements
  const mainImg = document.getElementById('rk-main-img');
  const thumbnails = document.querySelectorAll('.rk-product-hero__thumb');
  const variantIdInput = document.getElementById('rk-variant-id');
  const priceEl = document.getElementById('rk-price');
  const skuEl = document.getElementById('rk-sku');
  const stockEl = document.getElementById('rk-stock');
  const addToCartBtn = document.getElementById('rk-add-to-cart');
  const qtyInput = document.getElementById('rk-qty-input');
  const qtyMinus = document.getElementById('rk-qty-minus');
  const qtyPlus = document.getElementById('rk-qty-plus');
  const productForm = document.getElementById('rk-product-form');
  const wishlistBtn = productSection.querySelector('.rk-product-hero__wishlist');
  const shareBtn = document.getElementById('rk-share-btn');
  const zoomBtn = document.getElementById('rk-zoom-btn');
  const lightbox = document.getElementById('rk-lightbox');
  const deliveryDateEl = document.getElementById('rk-delivery-date');
  
  // Current selections
  let currentOptions = {};

  // ==========================================
  // HELPER: Hauptbild setzen
  // srcset muss geleert werden, da Browser es über src priorisieren
  // ==========================================

  function setMainImage(imageUrl, zoomUrl) {
    if (!mainImg) return;
    mainImg.srcset = '';
    mainImg.src = imageUrl;
    if (zoomUrl) {
      mainImg.dataset.zoom = zoomUrl;
    }
  }
  
  // ==========================================
  // PRELOAD THUMBNAIL IMAGES
  // ==========================================

  function preloadThumbnailImages() {
    thumbnails.forEach(thumb => {
      const img = new Image();
      img.src = thumb.dataset.image;
    });
  }

  preloadThumbnailImages();

  // ==========================================
  // THUMBNAIL NAVIGATION
  // ==========================================
  
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const imageUrl = this.dataset.image;
      const zoomUrl = this.dataset.zoom;
      
      // Hauptbild updaten (srcset leeren, damit src greift)
      setMainImage(imageUrl, zoomUrl);
      
      // Active-State updaten
      thumbnails.forEach(t => t.classList.remove('rk-product-hero__thumb--active'));
      this.classList.add('rk-product-hero__thumb--active');
    });
  });
  
  // ==========================================
  // VARIANT SELECTION
  // ==========================================
  
  // Initialize current options
  if (product && product.options) {
    product.options.forEach((option, index) => {
      if (option.values && option.values.length > 0) {
        currentOptions['option' + (index + 1)] = option.values[0];
      }
    });
    console.log('RK Product Hero - Current options initialized:', currentOptions);
  }
  
  // Variant Buttons
  const variantButtons = productSection.querySelectorAll('.rk-product-hero__option-btn');
  variantButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const optionPosition = this.dataset.option;
      const optionValue = this.dataset.value;
      
      // Update UI - Remove active from all buttons in this option group
      const optionGroup = this.closest('.rk-product-hero__option');
      optionGroup.querySelectorAll('.rk-product-hero__option-btn').forEach(b => {
        b.classList.remove('rk-product-hero__option-btn--active');
      });
      
      // Add active to clicked button
      this.classList.add('rk-product-hero__option-btn--active');
      
      // Update selected text
      const selectedText = optionGroup.querySelector('[id^="rk-selected-"]');
      if (selectedText) {
        selectedText.textContent = optionValue;
      }
      
      // Update current options
      currentOptions['option' + optionPosition] = optionValue;
      
      // Find matching variant
      updateVariant();
    });
  });
  
  // Variant Dropdowns
  const variantSelects = productSection.querySelectorAll('.rk-product-hero__option-select');
  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const optionPosition = this.dataset.option;
      const optionValue = this.value;
      
      // Update current options
      currentOptions['option' + optionPosition] = optionValue;
      
      // Find matching variant
      updateVariant();
    });
  });
  
  function updateVariant() {
    if (!product || !product.variants) return;
    
    // Find matching variant
    const variant = product.variants.find(v => {
      return v.option1 === currentOptions.option1 &&
             (v.option2 === currentOptions.option2 || !currentOptions.option2) &&
             (v.option3 === currentOptions.option3 || !currentOptions.option3);
    });
    
    if (variant) {
      // Update variant ID
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }
      
      // Update price
      if (priceEl) {
        let priceHTML = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML = '<span class="rk-product-hero__price--sale">' + formatMoney(variant.price) + '</span>' +
                      '<span class="rk-product-hero__price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceHTML = '<span class="rk-product-hero__price--regular">' + formatMoney(variant.price) + '</span>';
        }
        priceEl.innerHTML = priceHTML;
      }
      
      // Update SKU
      if (skuEl && variant.sku) {
        skuEl.textContent = variant.sku;
      }
      
      // Update stock
      if (stockEl) {
        updateStock(variant);
      }
      
      // Update add to cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>In den Warenkorb';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Ausverkauft';
        }
      }
      
      // Update image if variant has image
      if (variant.featured_image && mainImg) {
        const newImageUrl = variant.featured_image.src;
        const zoomUrl = newImageUrl.replace(/(\.[^.]+)$/, '_2400x$1');

        // srcset leeren, damit src-Zuweisung greift
        setMainImage(newImageUrl, zoomUrl);
        
        // Update thumbnails - mark the matching one as active
        thumbnails.forEach(thumb => {
          const thumbMediaId = thumb.dataset.mediaId;
          if (variant.featured_image && thumbMediaId == variant.featured_image.id) {
            thumb.classList.add('rk-product-hero__thumb--active');
          } else {
            thumb.classList.remove('rk-product-hero__thumb--active');
          }
        });
      }
    }
  }
  
  function updateStock(variant) {
    const inventory = variant.inventory_quantity;
    const threshold = 10;
    
    let stockHTML = '';
    if (inventory > 0 && inventory <= threshold) {
      stockHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>Nur noch <strong>' + inventory + '</strong> auf Lager!';
    } else if (inventory > 0) {
      stockHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>Auf Lager';
    }
    
    stockEl.innerHTML = stockHTML;
  }
  
  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }
  
  // ==========================================
  // DELIVERY DATE CALCULATION
  // ==========================================
  
  function calculateDeliveryDate() {
    console.log('RK Product Hero - calculateDeliveryDate called');
    
    if (!deliveryDateEl) {
      console.warn('RK Product Hero: Delivery date element not found');
      return;
    }
    
    if (!deliverySettings) {
      console.warn('RK Product Hero: Delivery settings not found');
      deliveryDateEl.textContent = '1-2 Werktage Standardversand';
      return;
    }
    
    const lieferzeit = deliverySettings.lieferzeit;
    const standardVersand = deliverySettings.standardVersand;
    
    console.log('RK Product Hero - Delivery Settings:', { 
      lieferzeit: lieferzeit, 
      standardVersand: standardVersand,
      lieferzeitType: typeof lieferzeit,
      lieferzeitValue: lieferzeit
    });
    
    // Wenn keine Lieferzeit definiert ist, nur Standardversand anzeigen
    if (!lieferzeit || lieferzeit === '' || lieferzeit === null) {
      console.log('RK Product Hero - No lieferzeit, showing standard only');
      deliveryDateEl.textContent = standardVersand + ' Werktage Standardversand';
      return;
    }
    
    // Parse lieferzeit (z.B., "3-4")
    const lieferzeitMatch = lieferzeit.toString().match(/(\d+)-(\d+)/);
    if (!lieferzeitMatch) {
      console.warn('RK Product Hero: Lieferzeit format nicht erkannt:', lieferzeit);
      deliveryDateEl.textContent = lieferzeit + ' + ' + standardVersand + ' Werktage';
      return;
    }
    
    const lieferzeitMin = parseInt(lieferzeitMatch[1]);
    const lieferzeitMax = parseInt(lieferzeitMatch[2]);
    
    // Parse standard versand (z.B., "1-2")
    const versandMatch = standardVersand.toString().match(/(\d+)-(\d+)/);
    if (!versandMatch) {
      console.warn('RK Product Hero: Standardversand format nicht erkannt:', standardVersand);
      deliveryDateEl.textContent = lieferzeit + ' + ' + standardVersand + ' Werktage';
      return;
    }
    
    const versandMin = parseInt(versandMatch[1]);
    const versandMax = parseInt(versandMatch[2]);
    
    // Calculate total days
    const totalMinDays = lieferzeitMin + versandMin;
    const totalMaxDays = lieferzeitMax + versandMax;
    
    console.log('RK Product Hero - Total days:', { totalMinDays: totalMinDays, totalMaxDays: totalMaxDays });
    
    try {
      // Calculate dates (excluding weekends)
      const minDate = addBusinessDays(new Date(), totalMinDays);
      const maxDate = addBusinessDays(new Date(), totalMaxDays);
      
      // Format dates
      const minDay = minDate.getDate();
      const maxDay = maxDate.getDate();
      const minMonth = minDate.toLocaleDateString('de-DE', { month: 'long' });
      const maxMonth = maxDate.toLocaleDateString('de-DE', { month: 'long' });
      const year = maxDate.getFullYear();
      
      // Formatierung je nachdem ob gleicher Monat oder nicht
      let dateText;
      if (minMonth === maxMonth) {
        dateText = 'Du erhältst dein Paket zwischen dem <strong>' + minDay + '. und ' + maxDay + '. ' + maxMonth + ' ' + year + '</strong>';
      } else {
        dateText = 'Du erhältst dein Paket zwischen dem <strong>' + minDay + '. ' + minMonth + '</strong> und <strong>' + maxDay + '. ' + maxMonth + ' ' + year + '</strong>';
      }
      
      deliveryDateEl.innerHTML = dateText;
      console.log('RK Product Hero - Delivery date set successfully:', dateText);
    } catch (error) {
      console.error('RK Product Hero - Error calculating delivery date:', error);
      deliveryDateEl.textContent = lieferzeit + ' + ' + standardVersand + ' Werktage';
    }
  }
  
  function addBusinessDays(date, days) {
    let currentDate = new Date(date);
    let addedDays = 0;
    
    while (addedDays < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        addedDays++;
      }
    }
    
    return currentDate;
  }
  
  // Initialize delivery date - use setTimeout to ensure DOM is fully loaded
  setTimeout(function() {
    try {
      calculateDeliveryDate();
    } catch (error) {
      console.error('RK Product Hero - Error in calculateDeliveryDate:', error);
    }
  }, 100);
  
  // ==========================================
  // QUANTITY CONTROLS
  // ==========================================
  
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      if (currentQty > 1) {
        qtyInput.value = currentQty - 1;
      }
    });
  }
  
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function() {
      const currentQty = parseInt(qtyInput.value) || 1;
      qtyInput.value = currentQty + 1;
    });
  }
  
  // ==========================================
  // ADD TO CART
  // ==========================================
  
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const button = this.querySelector('button[type="submit"]');
      const originalHTML = button.innerHTML;
      
      // Disable button
      button.disabled = true;
      button.innerHTML = '<div class="rk-product-hero__spinner"></div>';
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Success
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>Hinzugefügt!';
        
        // Dispatch cart update event
        document.dispatchEvent(new CustomEvent('cartUpdated'));
        
        // Reset after 2 seconds
        setTimeout(function() {
          button.innerHTML = originalHTML;
          button.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        button.innerHTML = originalHTML;
        button.disabled = false;
      });
    });
  }
  
  // ==========================================
  // WISHLIST
  // ==========================================
  
  if (wishlistBtn) {
    // Load wishlist state
    const wishlist = JSON.parse(localStorage.getItem('rk-wishlist') || '[]');
    const productId = wishlistBtn.dataset.productId;
    
    if (wishlist.includes(productId)) {
      wishlistBtn.classList.add('rk-product-hero__wishlist--active');
    }
    
    wishlistBtn.addEventListener('click', function() {
      this.classList.toggle('rk-product-hero__wishlist--active');
      
      let wishlist = JSON.parse(localStorage.getItem('rk-wishlist') || '[]');
      
      if (this.classList.contains('rk-product-hero__wishlist--active')) {
        if (!wishlist.includes(productId)) {
          wishlist.push(productId);
        }
      } else {
        wishlist = wishlist.filter(id => id !== productId);
      }
      
      localStorage.setItem('rk-wishlist', JSON.stringify(wishlist));
      
      // Dispatch event
      document.dispatchEvent(new CustomEvent('wishlistUpdated', { 
        detail: { count: wishlist.length } 
      }));
    });
  }
  
  // ==========================================
  // SHARE
  // ==========================================
  
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href
        }).catch(err => console.log('Share failed:', err));
      } else {
        // Fallback: Copy to clipboard
        navigator.clipboard.writeText(window.location.href).then(function() {
          const originalText = shareBtn.innerHTML;
          shareBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>Link kopiert!';
          
          setTimeout(function() {
            shareBtn.innerHTML = originalText;
          }, 2000);
        });
      }
    });
  }
  
  // ==========================================
  // ZOOM / LIGHTBOX
  // ==========================================
  
  if (zoomBtn && lightbox) {
    const lightboxImg = document.getElementById('rk-lightbox-img');
    const lightboxClose = lightbox.querySelector('.rk-product-hero__lightbox-close');
    
    zoomBtn.addEventListener('click', function() {
      const zoomUrl = mainImg.dataset.zoom;
      if (zoomUrl && lightboxImg) {
        lightboxImg.src = zoomUrl;
        lightbox.classList.add('rk-product-hero__lightbox--active');
        document.body.style.overflow = 'hidden';
      }
    });
    
    function closeLightbox() {
      lightbox.classList.remove('rk-product-hero__lightbox--active');
      document.body.style.overflow = '';
    }
    
    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }
    
    lightbox.addEventListener('click', function(e) {
      if (e.target === this) {
        closeLightbox();
      }
    });
    
    // ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('rk-product-hero__lightbox--active')) {
        closeLightbox();
      }
    });
  }
  
})();